import classNames from "classnames";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ArrowRotateLeft14x14Icon } from "~@/icons";
import { sanitize } from "~@/utils";

type TechnicalErrorProps = {
  isFullheight?: boolean;
};

const TechnicalError: FC<TechnicalErrorProps> = ({ isFullheight }) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames("error", {
        "error--is-fullheight": isFullheight,
      })}
    >
      <p className="error__title">{sanitize({ html: t("error.oops") })}</p>
      <p className="error__subtitle">{t("error.we-know")}</p>
      <p className="error__subtitle">{t("error.reload").toLowerCase()}</p>
      <button
        onClick={() => window.location.reload()}
        className="button button--h-48 button--fill-black-0"
      >
        <span className="icon-text">
          <span> {t("action.update-page")}</span>
          <span className="icon icon--is-14x14">
            <ArrowRotateLeft14x14Icon />
          </span>
        </span>
      </button>
    </div>
  );
};

export default TechnicalError;
